import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

export  abstract class AbstractHttp {


    constructor(private http: HttpClient, private url: string) { }



    get<Y>(params?: HttpParams, headers?: HttpHeaders): Observable<Y> {
        return this.http.get<Y>(this.url, { headers, params }).pipe(map((data: any) => {
            return this.filterData(data);
        }));
    }

    post<Y>(body?: HttpParams | string, headers?: HttpHeaders): Observable<Y> {
        return this.http.post<Y>(this.url, body, { headers: headers }).pipe(map((data: any) => {
            return this.filterData(data);
        }));
    }

    put<Y>(body?: HttpParams | string, headers?: HttpHeaders): Observable<Y> {
        return this.http.put<Y>(this.url, body, { headers: headers }).pipe(map((data: any) => {
            return this.filterData(data);
        }));
    }

    delete<Y>(params?: HttpParams, headers?: HttpHeaders): Observable<Y> {
        return this.http.delete<Y>(this.url, { headers, params }).pipe(map((data: any) => {
            return this.filterData(data);
        }));
    }

    filterData(data: any): any {
        if (data.contents) {
            return data.contents;
        } else {
            return data;
        }
    }

}
